(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coupon"] && !Shopify.designMode) return;
  try {
    
    let copyText = document.querySelector(".copy-text");
    copyText.querySelector("button").addEventListener("click", function () {
  	let input = copyText.querySelector("input.text");
  	input.select();
  	document.execCommand("copy");
  	copyText.classList.add("active");
  	window.getSelection().removeAllRanges();
  	setTimeout(function () {
  		copyText.classList.remove("active");
  	}, 2500);
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  let slides = document.querySelectorAll('.banner-slide');
  let dots = document.querySelectorAll('.dot');
  let index = 0;

  function showSlide(i) {
    slides.forEach((s, n) => {
      s.classList.toggle('active', n === i);
      dots[n].classList.toggle('active', n === i);
    });
  }

  const next = () => {
    index = (index + 1) % slides.length;
    showSlide(index);
  };

  let interval = setInterval(next, 7000);

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      clearInterval(interval);
      showSlide(i);
      index = i;
      interval = setInterval(next, 10000);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle"]) return;
  try {
    
  let addBtns = document.querySelectorAll(".add-btn");
  addBtns.forEach((addBtn) => {
    addBtn.addEventListener("click", (e) => {
    e.target.parentElement.style.display = "none";
    e.target.parentElement.parentElement.querySelector(".bundle-item-selector").style.display = "block";
    e.target.parentElement.parentElement.querySelector(".plus button").click();
  })
  })
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
